import type { FaireProductEntity } from "../../entity_types/product";

export const p_5cp72yb7fk: FaireProductEntity = {
  token: "p_5cp72yb7fk",
  type: "product",
  name: "Satin Sleep Mask - Floral Eye Mask for Beauty Sleep",
  brandToken: "b_72ivqmkinu",
  brandName: "Crover",
  imageUrl:
    "https://cdn.faire.com/fastly/cbd37f9fb1b70c47837d62e807d3c9de838be48e20475feb743407a028daacf8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85f2e16b88b0bb86a4e921d2b3be9cc85e567eb51639eb98ef720d7c1900b82b.jpeg",
    "https://cdn.faire.com/fastly/933ee28762b32ada2fa68f245076c8acacfa5cc37ca76745cbca571a8627caad.jpeg",
    "https://cdn.faire.com/fastly/d58f26669a4059ff0a7c38780197da76ca64b0cb13399e8a065fac1a74718076.png",
    "https://cdn.faire.com/fastly/813b0ab113d2b66ae26d358f2d553dab59137cfa2cf87bf38fa925b50783b39d.jpeg",
  ],
  priceDollars: 7.62,
  description:
    "A satin sleep mask designed to help block distracting light for a more restful night’s sleep. This soft floral eye mask is a giftable self-care accessory with elegant color box packaging for boutiques, spa shops, and beauty retailers.\n\nKey Features\n\nSoft satin sleep mask\n\nHelps block distracting light\n\nComfortable elastic strap for secure wear\n\nFloral print design with giftable appeal\n\nGreat for bedtime, travel, and self-care routines\n\nPackaged in a retail-ready color box\n\nIdeal for boutiques, spa shops, and beauty retailers\n\nPrice on Faire is per Piece; case pack includes 12 pieces.",
  tags: [],
  msrpDollars: 15.23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:24:36.455Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
